import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

// User Card Components
export const UserCard = styled(Box)<{
  variant?: 'primary' | 'danger' | 'neutral';
}>`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid
    ${({ variant }: { variant?: 'primary' | 'danger' | 'neutral' }) => {
      if (variant === 'danger') return 'rgba(231, 0, 11, 0.3)';
      if (variant === 'primary') return 'rgba(21, 93, 252, 0.3)';
      return 'rgba(0, 0, 0, 0.1)';
    }};
  background-color: ${({
    variant,
  }: {
    variant?: 'primary' | 'danger' | 'neutral';
  }) => {
    if (variant === 'danger') return '#FFEBEE';
    if (variant === 'primary') return '#E8F0FF';
    return '#f5f5f5';
  }};
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0;
`;

export const StyledAvatar = styled(Avatar)<{ variant?: 'primary' | 'danger' }>`
  width: 56px;
  height: 56px;
  background-color: ${({ variant }: { variant?: 'primary' | 'danger' }) =>
    variant === 'danger' ? '#E7000B' : '#155DFC'};
`;

// Info/Summary Box Components
export const InfoBox = styled(Box)`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
`;

export const InfoRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
  &:first-of-type {
    margin-top: 0;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

// Warning Box Component
export const WarningBox = styled(Box)`
  background-color: #ffebee;
  border: 1px solid rgba(231, 0, 11, 0.3);
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

// Action Button Components
export const PrimaryActionButton = styled(Button)`
  background-color: #155dfc;
  color: white;
  &:hover {
    background-color: #0d47d4;
  }
`;

export const DangerActionButton = styled(Button)`
  background-color: #e7000b;
  color: white;
  &:hover {
    background-color: #c20009;
  }
`;

export const DangerOutlineButton = styled(Button)`
  color: #e7000b;
  border-color: #e7000b;
  &:hover {
    border-color: #d9463a;
    background-color: rgba(231, 0, 11, 0.1);
  }
`;

// Job Counter Components
export const JobCounterContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
`;

export const CounterButton = styled(IconButton)`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
`;

export const CountDisplay = styled(Box)`
  background-color: #f5f5f5;
  padding: 12px 40px;
  border-radius: 8px;
  min-width: 80px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
`;

// Dropdown Section
export const DropdownSection = styled(Box)`
  margin: 24px 0 16px 0;
`;
